module.exports = __webpack_public_path__ + "static/img/banner_eng.a22284ee.png";